<div class="modal" [class.is-active]="true">
  <div class="modal-background"></div>
  <div class="modal-card space-allocation-modal">
    <header class="modal-card-head">
      <p class="modal-card-title">Adjust Space Allocation</p>
      <button class="delete" aria-label="close" (click)="onClose()"></button>
    </header>
    <section class="modal-card-body">
      <div class="linked-lots">
        @for (lot of parkingLots; track lot) {
          <div>
            <div class="box">
              <p class="title is-5">{{lot.name}}</p>
              <p class="subtitle is-6">Current Spaces: {{lot.totalSpaces}}</p>
            </div>
          </div>
        }
      </div>
      <div class="total-spaces">
        Total Spaces: {{parkingLots[0].totalSpaces + parkingLots[1].totalSpaces}} / {{originalTotal}}
      </div>
      @for (lot of parkingLots; track lot; let i = $index) {
        <div>
          <div class="slider-container">
            <div class="number-input-container">
              <input type="number"
                class="input"
                [min]="0"
                [max]="originalTotal"
                [value]="lot.totalSpaces"
                (input)="onNumberInputChange($event, i)">
              </div>
              <input type="range"
                class="slider is-fullwidth"
                [min]="0"
                [max]="originalTotal"
                [value]="lot.totalSpaces"
                (input)="onSpaceAllocationChange($event, i)">
              </div>
            </div>
          }
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" (click)="onSave()">OK</button>
          <button class="button" (click)="onClose()">Cancel</button>
        </footer>
      </div>
    </div>